@if (isVisible) {
    <button
        type="button"
        class="need-help-fab"
        aria-label="Need help?"
        (click)="open()"
    >
        <span
            class="need-help-icon"
            aria-hidden="true"
        >
            ?
        </span>
        <span class="need-help-text">Need help?</span>
    </button>
}

<ng-template
    #needHelpModal
    let-modal
>
    <div class="modal-header">
        <h5 class="modal-title">Need help?</h5>
        <button
            type="button"
            class="close"
            aria-label="Close"
            (click)="modal.dismiss()"
        >
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <div class="modal-body">
        <p>Submit a support ticket and our team will assist you.</p>
        <div class="need-help-actions">
            <button
                type="button"
                class="btn btn-save"
                (click)="createTicket()"
            >
                Create a Ticket
            </button>
        </div>

        @if (loading) {
            <p class="text-muted mt-3 mb-0">Loading your team's contact...</p>
        } @else if (needHelp?.hasAfterHoursContact) {
            <hr />
            <h6>After-Hours Support Contact</h6>
            <p class="text-muted contact-note">
                For immediate assistance, you can reach your team's after-hours
                contact:
            </p>
            <div class="contact-card">
                @if (needHelp.contactName) {
                    <div class="contact-name">{{ needHelp.contactName }}</div>
                }
                @if (needHelp.contactPhone) {
                    <div>
                        <a [href]="'tel:' + needHelp.contactPhone">
                            {{ needHelp.contactPhone }}
                        </a>
                    </div>
                }
                @if (needHelp.contactEmail) {
                    <div>
                        <a [href]="'mailto:' + needHelp.contactEmail">
                            {{ needHelp.contactEmail }}
                        </a>
                    </div>
                }
            </div>
        }
    </div>
</ng-template>
